import React, { useEffect, useState } from 'react';

import NoteForm from './components/NoteForm';
import useTitle from 'hooks/useTitle';
import * as noteService from 'services/note';
import { handleError } from 'utils/errorHandler';
import Loading from 'components/common/loading/Loading';
import BackButton from 'components/common/button/BackButton';
import { RouteComponentProps } from 'react-router-dom';
import { NoteItem } from 'interface/note';

interface CreateEditNoteRouteParams {
  userId?: string;
  noteId?: string;
}

type CreateEditNoteProps = RouteComponentProps<CreateEditNoteRouteParams>;

const CreateEditNote: React.FC<CreateEditNoteProps> = (props) => {
  const noteId = props.match.params && props.match.params.noteId;
  const [isLoading, setIsLoading] = useState(Boolean(noteId));
  const title = noteId ? 'Edit Note' : 'Add Note';
  const [note, setNote] = useState<NoteItem | null>(null);

  useTitle(title);

  useEffect(() => {
    if (!noteId) {
      return;
    }

    const fetchNote = async () => {
      try {
        const { data } = await noteService.fetchNoteById(noteId);

        setNote(data as NoteItem);
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchNote();
  }, [noteId]);

  return (
    <main>
      <div className="container">
        <div className="full-scope-card">
          <div className="full-scope-card__header table-header name-wrap">
            <div className="d-flex flex-row">
              <BackButton />
              <div className="d-flex flex-row">
                <div className="table-header">
                  <span className="table-header__title">{title}</span>
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div className="loading-min-height">
              <Loading />
            </div>
          ) : (
            <NoteForm location={props.location} note={note} />
          )}
        </div>
      </div>
    </main>
  );
};

export default CreateEditNote;
